// 查找最近的一个需要上报埋点的元素
function findTrackElement(el: Element | null): Element | null {
  if (!el) return null

  const trackEvent = el.getAttribute('data-track-event')
  if (trackEvent) return el

  return findTrackElement(el.parentElement)
}

// 获取当前元素属性中携带的所有需要上报的事件属性
function getTrackProperties(el: Element) {
  const properties: Record<string, string> = {}
  const attrs = el.attributes
  const nameReg = /data-track-prop-(.+)/i

  for (let i = 0; i < attrs.length; i++) {
    const { name, value } = attrs[i]
    const matched = name.match(nameReg)
    if (matched && matched[1]) {
      properties[matched[1]] = value
    }
  }

  return properties
}

// 监听全页面点击事件，自动识并上报自定义埋点事件
export function autoTrackClickEvent(trackTrigger: any) {
  const clickHandler = (e: Event) => {
    const target = e.target as Element
    const trackEl = findTrackElement(target)

    if (trackEl) {
      const trackEvent = trackEl.getAttribute('data-track-event')
      const trackProps = getTrackProperties(trackEl)

      // 上报埋点事件
      trackTrigger(trackEvent, trackProps)
    }
  }

  document.removeEventListener('click', clickHandler)
  document.addEventListener('click', clickHandler, true)
}

function getNavigationTiming() {
  const [entry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[]

  const timing = {
    // 重定向耗时
    time_redirect: entry.redirectEnd - entry.redirectStart,
    // DNS 解析耗时
    time_dns: entry.domainLookupEnd - entry.domainLookupStart,
    // TCP 连接耗时
    time_tcp: entry.connectEnd - entry.connectStart,
    // SSL 安全连接耗时
    time_ssl: entry.connectEnd - entry.secureConnectionStart,
    // 网络请求耗时 (TTFB)
    time_ttfb: entry.responseStart - entry.requestStart,
    // 数据传输耗时
    time_download: entry.responseEnd - entry.responseStart,
    // DOM 解析耗时
    time_dom_parse: entry.domInteractive - entry.responseEnd,
    // 首次可交互时间
    time_dom_interactive: entry.domInteractive - entry.fetchStart,
    // DOM Ready 时间
    time_dom_ready: entry.domContentLoadedEventEnd - entry.fetchStart,
    // 页面完全加载时间
    time_page_loaded: entry.loadEventStart - entry.fetchStart,
    // 首包时间
    time_http_first_pkg: entry.responseStart - entry.domainLookupStart,
    // http 头部大小
    time_http_head_size: entry.transferSize - entry.encodedBodySize
  }

  return timing
}

/**
 * 获取 FP & FCP 时间
 * @returns
 */
function getPaintTiming() {
  const [fp, fcp] = performance.getEntriesByType('paint')
  const timing = {
    time_fp: fp && fp.startTime,
    time_fcp: fcp && fcp.startTime
  }

  return timing
}

export function getPerformanceTiming() {
  const navigationTiming = getNavigationTiming()
  const paintTiming = getPaintTiming()

  return { ...navigationTiming, ...paintTiming }
}
